import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Bird from '../animations/Bird';
import PicnicBasket from '../animations/PicnicBasket';
import Cup, { ANIMATION_FINISHED } from '../game/Cup';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import StackGameButton from '../ui/StackGameButton';
import UIAssetKeys from '../UIAssetKeys';
import { getGameBackground } from './GameBackground';
import Instructions from './Instructions';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import LocalizationUIAssets from '../Localization-UIAssets';

/**
 * This is your first scene.
 */
export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    this.sound.setMute(false);

    this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2, 0, LocalizationUIAssets._title_0, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.title.scale = Phaser.Math.Clamp((this.scale.width - 60) / this.title.width, 0, 1);
    this.title.y = -((this.title.height * this.title.scaleY) + 50);
    this.title.alpha = 0;

    this.basket = new PicnicBasket(this, this.scale.width + 10, gameData.isMobile ? (this.scale.height / 2) - 160 : (this.scale.height / 2) - 30);

    this.goBtn = new StackGameButton(this, this.scale.width / 2, 0);
    let bottomOffset = gameData.isMobile ? 75 : -10;
    this.goBtn.y = this.scale.height - (this.goBtn.height / 2) - bottomOffset;
    this.goBtn.alpha = 0;

    this.bird = new Bird(this, 0, 0);
    this.bird.x = -(this.bird.body.width + 50);

    this.gameBackground = getGameBackground();
    this.gameBackground.setHorizon("low");
    this.gameBackground.resetToBlanket();

    this.time.delayedCall(100, this.startIntro, null, this);

    //ABCyaPhaser.Debug.addScreenReference(this, "ref", "assets/1 Title-01.png")
  }

  startIntro() {
    ABCyaPhaser.Tweens.addTween(this.title, 1500, { y: this.scale.height / 4 - (gameData.isMobile ? 50 : 40), alpha: 1, completeDelay: 500 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.startCupDrop()
    });

    this.time.delayedCall(500, this.gameBackground.pan, ["down"], this.gameBackground);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._title_bird_singing, this, 1, false, 0.5);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cup_stacking_title_fall, this, 1, false, 0.5);
  }

  startCupDrop() {
    this.cups = [];
    let colors = ["yellow", "red", "blue"];
    while (this.cups.length < 3) {
      let cup = new Cup(this, 0, 0, colors[this.cups.length], "");
      switch (cup.cupBase.frame.name) {
        case UIAssetKeys._game_items_cup_blue_0:
          cup.cupBase.setFrame(UIAssetKeys._game_items_cup_blue_title_0);
          break;
        case UIAssetKeys._game_items_cup_red_0:
          cup.cupBase.setFrame(UIAssetKeys._game_items_cup_red_title_0);
          break;
        case UIAssetKeys._game_items_cup_yellow_0:
          cup.cupBase.setFrame(UIAssetKeys._game_items_cup_yellow_title_0);
          break;
      }

      //drop in
      let endX;
      if (this.cups.length == 0) {
        endX = (this.scale.width / 2 - ((cup.cupBase.width / 2) * cup.scaleX));
      }
      else if (this.cups.length == 1) {
        endX = (this.scale.width / 2 + ((cup.cupBase.width / 2) * cup.scaleX));
      } else {
        endX = (this.scale.width / 2);
      }

      let endY;
      if (gameData.isMobile) {
        endY = (this.cups.length < 2) ? (this.scale.height * .75) - 200 : (this.scale.height * .75) - (cup.cupBase.height * cup.scaleY) - 170;
      }
      else {
        endY = (this.cups.length < 2) ? (this.scale.height * .75) - 58 : (this.scale.height * .75) - (cup.cupBase.height * cup.scaleY) - 28;
      }
      cup.once(ANIMATION_FINISHED, this.handleCupDrop, this);

      this.time.delayedCall(200 * this.cups.length, () => {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._whoosh, this, 1, false, 0.25);
        cup.dropIn(endX, endY);
      });

      this.cups.push(cup);
    }
  }

  handleCupDrop(cup) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cup, this);

    if (cup === this.cups[this.cups.length - 1]) {
      //add basket fly in bird
      ABCyaPhaser.Tweens.addTween(this.basket, 500, { x: this.scale.width - this.basket.width - 50 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._basket_menu_tween, this, 1, false, 0.25);
      //move bird to top of cups
      this.children.bringToTop(this.bird);

      this.bird.flyTo(gameData.isMobile ? 50 : 80, gameData.isMobile ? this.scale.height - this.bird.body.height - 350 : this.scale.height - this.bird.body.height - 150, 1000);
      this.time.delayedCall(1000, this.introReady, null, this);
    }
  }

  introReady() {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._cup_stacking_title, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.goBtn.popIn();
    this.goBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startFinish, this);
  }

  startFinish() {
    this.tweens.killTweensOf(this.goBtn);
    this.goBtn.disableInteractive();

    //first bird hop to cups
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bird_jump_fly_tween, this);

    this.bird.jumpTo(this.cups[this.cups.length - 1].x - ((this.bird.body.width / 2) * .9), this.cups[this.cups.length - 1].y - (this.cups[this.cups.length - 1].cupBase.height / 2) - (this.bird.body.height * .9), 700);
    ABCyaPhaser.Tweens.addTween(this.bird, 700, { scale: 0.9 }, Phaser.Math.Easing.Linear, this.secondHop.bind(this));

    ABCyaPhaser.Tweens.addTween(this.goBtn, 300, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  secondHop() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bird_jump_fly_tween, this);

    this.bird.jumpTo(this.basket.x + 50, this.basket.y + 60, 1000);

    ABCyaPhaser.Tweens.addTween(this.bird, 1000, { scale: 0.8 }, Phaser.Math.Easing.Linear, () => {
      this.moveOutCups();
    });
    this.time.delayedCall(500, () => this.children.sendToBack(this.bird));
  }

  moveOutCups() {
    this.bird.alpha = 0;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cups_leave_tween, this);

    this.cups[0].spinOff("left");
    this.time.delayedCall(50, this.cups[1].spinOff, ["left"], this.cups[1]);
    ABCyaPhaser.Tweens.addTween(this.cups[2], 200, { y: this.cups[2].y + (this.cups[2].cupBase.height * this.cups[2].scaleY) }, Phaser.Math.Easing.Linear, () => {
      this.cups[2].spinOff("left");
    });
    this.time.delayedCall(1500, this.endIntro, null, this);
  }

  endIntro() {
    ABCyaPhaser.Tweens.addTween(this.title, 500, { y: -this.title.height }, Phaser.Math.Easing.Quadratic.In);

    ABCyaPhaser.Tweens.addTween(this.basket, 1500, { x: -this.basket.width }, Phaser.Math.Easing.Linear, this.goToInstructions.bind(this));

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._basket_menu_tween, this);
  }

  goToInstructions() {
    this.gameBackground.pan("stop");

    this.scene.start(Instructions.KEY);
  }
}